var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            {
              attrs: {
                title: "Usuários do Sistema",
                icon: "fas fa-users fa-1x"
              }
            },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _vm.isAuthorized
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary", plain: "" },
                          on: { click: _vm.regraGrupos }
                        },
                        [
                          _c("i", { staticClass: "fas fa-check-double" }),
                          _vm._v("\n            Regras de Grupos\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.userCreateModal.toggleModal()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v("\n            Novo Usuário\n          ")
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "CardBase",
            [
              _c(
                "el-form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "mb-3 bg-red",
                      attrs: { type: "flex", gutter: 12, align: "bottom" }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("label", [_vm._v("Nome")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "Filtrar pelo nome..."
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.fetch()
                              }
                            },
                            model: {
                              value: _vm.filters.nome,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "nome", $$v)
                              },
                              expression: "filters.nome"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("label", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "Filtrar pelo Email..."
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.fetch()
                              }
                            },
                            model: {
                              value: _vm.filters.email,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "email", $$v)
                              },
                              expression: "filters.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("label", [_vm._v("Centro de Distribuição")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                placeholder: "Centro de distribuição",
                                disabled: _vm.loading,
                                filterable: ""
                              },
                              model: {
                                value: _vm.filters.cd,
                                callback: function($$v) {
                                  _vm.$set(_vm.filters, "cd", $$v)
                                },
                                expression: "filters.cd"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Todos", value: "" }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.centers, function(center) {
                                return _c("el-option", {
                                  key: center.value,
                                  attrs: {
                                    label: center.text,
                                    value: center.text
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("label", [_vm._v("Perfil do Usuário")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                placeholder: "Perfil do usuário",
                                disabled: _vm.loading,
                                filterable: ""
                              },
                              model: {
                                value: _vm.filters.perfil,
                                callback: function($$v) {
                                  _vm.$set(_vm.filters, "perfil", $$v)
                                },
                                expression: "filters.perfil"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Todos", value: "" }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.roles, function(role) {
                                return _c("el-option", {
                                  key: role.tipo,
                                  attrs: { label: role.text, value: role.tipo }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", disabled: _vm.loading },
                              on: {
                                click: function($event) {
                                  return _vm.fetch()
                                }
                              }
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", {
                                    attrs: {
                                      small: "",
                                      variant: "secondary",
                                      label: "Spinning"
                                    }
                                  })
                                : _c("i", { staticClass: "fas fa-search" }),
                              _vm._v("\n                Buscar\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "mini", disabled: _vm.loading },
                                on: {
                                  change: function($event) {
                                    return _vm.fetch()
                                  }
                                },
                                model: {
                                  value: _vm.filters.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "status", $$v)
                                  },
                                  expression: "filters.status"
                                }
                              },
                              _vm._l(
                                [
                                  { value: null, text: "Todos" },
                                  { value: "Sim", text: "Ativos" },
                                  { value: "Não", text: "Inativos" }
                                ],
                                function(stat) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      key: stat.text,
                                      attrs: { label: stat.value }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center"
                                        },
                                        [
                                          _c("span", { staticClass: "ml-1" }, [
                                            _vm._v(_vm._s(stat.text))
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "border rounded p-3 d-flex align-items-center"
                        },
                        [
                          _c("i", { staticClass: "el-icon-loading mr-2" }),
                          _vm._v("\n          Carregando usuários...\n        ")
                        ]
                      )
                    : !_vm.loading && _vm.users.length > 0
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "rounded",
                          attrs: {
                            "empty-text": "Nenhum usuário encontrado.",
                            data: _vm.users,
                            align: "center",
                            border: "",
                            "row-key": "id",
                            size: "mini"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "ID",
                              width: "80",
                              prop: "id",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _c("div", {}, [
                                    _vm._v(_vm._s(scope.row.id))
                                  ])
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "320",
                              label: "Nome",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.name))])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "300",
                              label: "E-mail",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.email != null
                                            ? scope.row.email
                                            : "-"
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "100",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status != undefined
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type:
                                                scope.row.status == true
                                                  ? "success"
                                                  : "danger"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  scope.row.status == true
                                                    ? "ATIVO"
                                                    : "INATIVO"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "120",
                              label: "Centro de Distr.",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.cd
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.cd.descricao))
                                        ])
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Não Associado\n                  "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "240",
                              label: "Regiões",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.regioes.length > 0
                                      ? _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom-end",
                                              trigger: "hover"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex flex-wrap",
                                                style: {
                                                  gap: "4px",
                                                  maxWidth: "fit-content"
                                                },
                                                attrs: { slot: "reference" },
                                                slot: "reference"
                                              },
                                              [
                                                _vm._l(
                                                  scope.row.regioes.slice(0, 5),
                                                  function(reg) {
                                                    return _c(
                                                      "el-tag",
                                                      {
                                                        key: reg.id,
                                                        attrs: { size: "mini" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(reg.uf) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                scope.row.regioes.length > 5
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type: "success",
                                                          size: "mini"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              "+" +
                                                                scope.row.regioes.slice(
                                                                  5
                                                                ).length
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex flex-wrap",
                                                style: {
                                                  gap: "4px",
                                                  maxWidth: "300px"
                                                }
                                              },
                                              _vm._l(
                                                scope.row.regioes.slice(5),
                                                function(reg) {
                                                  return _c(
                                                    "el-tag",
                                                    {
                                                      key: reg.id,
                                                      attrs: { size: "mini" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(reg.uf) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Sem região\n                  "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "200",
                              label: "Perfil",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.roles.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(scope.row.roles, function(
                                            role
                                          ) {
                                            return _c(
                                              "span",
                                              { key: role.id },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(role.label) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Não Associado\n                  "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Criado em",
                              width: "110",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                scope.row.created_at
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Última atualização",
                              width: "140",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                scope.row.updated_at
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                fixed: "right",
                                width: 50,
                                align: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between"
                                        },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom-end",
                                                trigger: "hover"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    slot: "reference",
                                                    size: "mini",
                                                    type: "info",
                                                    plain: "",
                                                    circle: "",
                                                    disabled: _vm.loading
                                                  },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-more"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  style: {
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    flexDirection: "column",
                                                    gap: "4px",
                                                    maxWidth: "300px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: { width: "100%" }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          style: {
                                                            width: "100%"
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            type: "warning",
                                                            plain: "",
                                                            disabled:
                                                              _vm.loading,
                                                            title:
                                                              "Editar usuário"
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.$refs.userEditModal.getUser(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-edit"
                                                          }),
                                                          _vm._v(
                                                            "\n                        Editar Usuário\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      style: { width: "100%" }
                                                    },
                                                    [
                                                      _vm.isAuthorized &&
                                                      scope.row.status
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              style: {
                                                                width: "100%"
                                                              },
                                                              attrs: {
                                                                size: "mini",
                                                                type: "success",
                                                                plain: "",
                                                                disabled:
                                                                  _vm.loading,
                                                                title:
                                                                  "Logar como"
                                                              },
                                                              nativeOn: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.showLoginAs(
                                                                    scope.row.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-sign-in-alt"
                                                              }),
                                                              _vm._v(
                                                                "\n                        Logar como\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      style: { width: "100%" }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          style: {
                                                            width: "100%"
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            type: "primary",
                                                            plain: "",
                                                            disabled:
                                                              _vm.loading,
                                                            title:
                                                              "Editar senha usuário"
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.$refs.userEditPasswordModal.handleEdit(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-key"
                                                          }),
                                                          _vm._v(
                                                            "\n                        Editar Senha\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [_c("i", { staticClass: "el-icon-menu" })]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _c("el-empty", {
                        attrs: { description: "Nenhum usuário disponível" }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "el-col",
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.filters.current_page,
                          "page-sizes": [15, 50, 75, 100],
                          "page-size": _vm.filters.per_page,
                          layout: "total, sizes, prev, pager, next",
                          total: _vm.filters.total
                        },
                        on: {
                          "update:currentPage": function($event) {
                            return _vm.$set(_vm.filters, "current_page", $event)
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(_vm.filters, "current_page", $event)
                          },
                          "current-change": _vm.fetch
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("UserCreateModal", { ref: "userCreateModal" }),
      _vm._v(" "),
      _c("UserEditModal", { ref: "userEditModal" }),
      _vm._v(" "),
      _c("UserEditPasswordModal", { ref: "userEditPasswordModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bbee836", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bbee836","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9bbee836","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/User/Index.vue
// module chunks = 2